export class AdjustmentAccountPeriodModel {
  Id: number;
  AdjustmentId: number;
  AccountId: string;
  AccountName: string;
  AccountNameTranslated: string;
  PeriodId: number;
  Period: string;
  PeriodTranslated: string;
  Amount: number;
  EntityId1: number;
  Entity1Name: string;
  EntityId2: number;
  Entity2Name: string;
  languageCode : string;
}
